<template>
  <div class="custom-pagination">
      <v-pagination
        :value="value"
        :length="pageCount"
        :total-visible="6"
        prev-icon="chevron_left"
        next-icon="chevron_right"
        @input="setPage($event)"
      />

    <span class="d-inline-block">
      <div class="custom-pagination__input">
        <v-text-field
          :value="value"
          solo
          hide-details
          @input="setPage($event)"
      /></div>

      <span class="custom-pagination__count">
        {{
          (value - 1) * limit +
            1 +
            '-' +
            (value * limit > total ? total : value * limit)
        }}
        of {{ total }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    total: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 1,
    },
  },

  data: () => ({
    page: 1,
    limit: 10,
    rules:{
      required:v=>!!v||'Required',
      min:v=>v>=1||'Enter a valid Page Number',

    }
  }),
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
  },
  methods: {
    setPage(event) {
      console.log('event',event)
      if (event > 0 && event <= this.pageCount) {
        const value = parseInt(event);

        this.value = value;
        this.$emit('input', value);
      }
    },
  },
};
</script>
<style lang="scss">

.custom-pagination {

  text-align: right;

  padding: 20px;

  width: 100%;

  ul {

    display: inline-block !important;

    width: auto;

    vertical-align: middle;

    li {

      display: inline-block !important;

      width: auto;

      vertical-align: middle;

      button {

        width: 30px !important;

        min-width: 30px !important;

        height: 30px !important;

      }

    }

  }

  &__input {

    max-width: 42px;

    display: inline-block;

    margin: 0 5px;

    .v-input__control {

      min-height: 30px !important;

    }

  }

  &__count {

    display: inline-block;

  }

}

</style>
